import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { AsyncPipe } from '@angular/common';
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { MatCalendar } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { selectFeatures, selectMakes, selectModels, selectProviderOffer, selectVersions } from 'src/app/common/store/state/app.state';
import { AppConstants } from 'src/app/public/common/constants/app-constants';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { GeneralBasicData } from 'src/app/public/common/constants/general-basic-data';
import { Country } from 'src/app/public/common/models/country.model';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { CarBasicData, CarBusinessLine } from '../../constants/car-basic-data';
import { CarEngine } from '../../models/car-engine.model';
import { CarFeature } from '../../models/car-feature.model';
import { CarMake } from '../../models/car-make.model';
import { CarModel } from '../../models/car-model.model';
import { CarVersion } from '../../models/car-version.model';
import { Car } from '../../models/car.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';



@Component({
    selector: 'provider-offer-dialog',
    templateUrl: './provider-offer-dialog.component.html',
    styleUrls: ['./provider-offer-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatDialogModule, MatProgressSpinnerModule, MatIconModule, MatDividerModule, AsyncPipe]
})
export class ProviderOfferDialogComponent implements OnInit, AfterViewInit, AfterViewChecked {
  
    formMessage = "";
    isNewOffer: boolean = false;
    isNewCar: boolean = false;

    providerOffer$ : Observable<Car | null>;
    providerOffer: Car = new Car();

    carBodyTypes = CarBasicData.bodyTypes;
    makes: string[];  
    //carModels: string[];
    makes$: Observable<CarMake[]>;
    models$: Observable<CarModel[]>;
    versions$: Observable<CarVersion[]>;

    features$: Observable<CarFeature[]>;

    selectedMake: CarMake = new CarMake('', '', 0);
    selectedModel: CarModel = new CarModel('', '');
    selectedVersion: CarVersion = new CarVersion('', '');
    selectedEngine: CarEngine = new CarEngine('', '');

    citiesBD: string [] = [];
    carGearBoxes = CarBasicData.gearboxes;
    carFuels = CarBasicData.fuelTypes;

    countryCodeOptions: string[] = AppConstants.COUNTRY_CODE_OPTIONS;
    carYearsBD: number[] = AppFunctions.getCarYearsBD();

    CarBusinessLine = CarBusinessLine

  constructor(
    private store: Store,
    private cdRef:ChangeDetectorRef,
    public dialogRef: MatDialogRef<ProviderOfferDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ObjectData,
        ) {
        this.makes = CarBasicData.getMakesBD();
        this.citiesBD = GeneralBasicData.getAllCities([this.providerOffer.country]);

        this.makes$ = this.store.select(selectMakes);
        this.models$ = this.store.select(selectModels);
        this.versions$ = this.store.select(selectVersions);   
        
        this.features$ = this.store.select(selectFeatures);

        this.providerOffer$ = store.select(selectProviderOffer(data.objectSource, data.carId, data.businessLine, data.offerId)); 
    }
  
  ngOnInit(): void {

    console.log('heyyyyyyyy ')
    console.log(this.data)

    this.isNewOffer = (this.data.offerId === "");
    this.isNewCar = (this.data.carId === "");
    
    if (this.isNewCar) {
      //console.log(this.data)

      this.store.dispatch(CarRefActions.makesFetchSubmit( {}));
      this.store.dispatch(CarRefActions.featuresFetchSubmit( {}));

      this.selectedMake.id = +this.providerOffer.makeId;
      this.selectedMake.name = this.providerOffer.make;

      this.selectedModel.id = +this.providerOffer.modelId;
      this.selectedModel.name = this.providerOffer.model;

      //this.selectedVersion.id = +this.providerOffer.versionId;
      this.selectedVersion.name = this.providerOffer.version;

      this.selectedEngine.id = +this.providerOffer.engineId;
      this.selectedEngine.name = this.providerOffer.engine;
      //this.selectedEngine = this.selectedVersion.engines.filter(eng => eng.id === +this.data.engineId)[0];

      this.makes$.pipe(
        take(2)
        ).subscribe(
          (makes: CarMake[]) => {
            this.selectedMake = makes.filter(make => make.id === this.providerOffer.makeId)[0];
            this.store.dispatch(CarRefActions.modelsFetchSubmit( { makeIds: [this.selectedMake.id] }));
            console.log('helloooo 2 '+ this.selectedMake)
          }
        );
  
        this.models$.pipe(
          take(3)
          ).subscribe(
            (models: CarModel[]) => {
              //this.selectedModel = new CarModel('', '');
              this.selectedModel = models.filter(model => model.id === this.providerOffer.modelId)[0];
              console.log(this.selectedModel);
              this.store.dispatch(CarRefActions.versionsFetchSubmit( {modelIds: [this.selectedModel.id]}));
              //console.log(this.selectedModel);
            }
          );
  
        this.versions$.pipe(
          take(4)
          ).subscribe(
            (versions: CarVersion[]) => {
              //this.selectedVersion = new CarVersion('', '');
              /// this.selectedVersion = versions.filter(version => version.id === this.providerOffer.versionId)[0];
              //this.store.dispatch(CarRefActions.enginesFetchAllSubmit());
              //console.log(this.selectedMake);
            }
          );
    }

    this.providerOffer$.subscribe(
            (result: Car | null) => {
              if(result == undefined || result == null){
                this.providerOffer = new Car()
                this.providerOffer.carId = this.data.carId;
                this.providerOffer.businessLine = this.data.businessLine
              }
              else{
                //this.proposal = Object.assign(new Proposal(), result)
                this.providerOffer = JSON.parse(JSON.stringify(result))
              }
              //this.reply = ""
            }
          );
  }
  
  ngAfterViewChecked(){

    this.updateCitiesBD(this.providerOffer.country)
    this.cdRef.detectChanges();
  }

  ngAfterViewInit(): void{

    this.updateCitiesBD(this.providerOffer.country)

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  
  getCarModels(mk: string): string[]{
    return CarBasicData.getModelsBD([mk]);
  }

  updateCitiesBD(country: string): void{

    this.citiesBD = GeneralBasicData.getAllCities([country]);
   
  }

  getCountryName(code: string){
    return GeneralBasicData.getCountryByCode(code)!.name;
  }

  getCountry(code: string): Country{
    
    let country: Country = GeneralBasicData.getCountryByCode(code)!;

    if(this.isNewOffer){
      // this.data.buyPrice.currency = country.currency;
      //this.data.rentPrice.currency = country.currency;
    }

    return country;
  }

  getCity(city: string){
    return city;
  }

  onMakeChange(make: CarMake){
    //console.log(make);
    this.providerOffer.makeId = make.id;
    this.providerOffer.make = make.name;
    this.providerOffer.model = '';
    this.providerOffer.version = '';
    this.selectedModel = new CarModel('','');
    this.selectedVersion = new CarVersion('','');
    this.store.dispatch(CarRefActions.modelsFetchSubmit( { makeIds: [make.id] } ));
  }

  onModelChange(model: CarModel){
    this.providerOffer.modelId = model.id;
    this.providerOffer.model = model.name;
    this.providerOffer.version = '';
    this.selectedVersion = new CarVersion('','');
    this.store.dispatch(CarRefActions.versionsFetchSubmit( { modelIds: [model.id] } ));
  }

  onVersionChange(version: CarVersion){
    console.log(version);
    this.providerOffer.version = version.name;
    //this.providerOffer.versionId = version.id;
    this.providerOffer.engine = '';
    this.selectedEngine = new CarEngine('','');
    this.providerOffer.gearBox = version.gearBox;
  }

  onEngineChange(engine: CarEngine){
    console.log(engine);
    this.providerOffer.engine = engine.name;
    this.providerOffer.engineId = engine.id;
    this.providerOffer.fuel = engine.fuel;
  }

  submitProviderOffer(){
  
    if(this.providerOffer.offerId === ''){
      console.log('new offer')
      this.store.dispatch(DealerActions.providerOfferNewSubmit({ providerOffer: this.providerOffer, objectSource: this.data.objectSource }));
    }
    else{

      console.log('update offer')
      this.store.dispatch(DealerActions.providerOfferUpdateSubmit({ providerOffer: this.providerOffer, objectSource: this.data.objectSource }));         
    
    }
    this.dialogRef.close();
  }

  dateFormat(dt: string): string{
  
    return AppFunctions.stringToDatetime(dt);
    
  }
}

